import { render, staticRenderFns } from "./userReports.vue?vue&type=template&id=79cfdb33&scoped=true&"
import script from "./userReports.vue?vue&type=script&lang=js&"
export * from "./userReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cfdb33",
  null
  
)

export default component.exports